export default class Locale_MoveRequestDialog { 
	FailedMovingRequest: string = "Failed moving request"
	MoveRequest: string = "Move request"
	SubText: string = "Select a timespan to move to a new start date. If needed move only a specific percentage of the request."
	
	FailedMovingProjectRequests: string = "Failed moving project requests"
	MoveProjectRequests: string = "Move project requests"
	ProjectSubText: string = "Select a timespan to move project requests to a new start date. If needed move only a specific percentage of each of the requests."
}